import { ThemedLotsController } from '../forum/controllers/ThemedLotsController.js';
import { AuthorThemedLotsController } from '../forum/controllers/AuthorThemedLotsController.js';
import { BasePage } from '../../base/BasePage.js';

export class ForumPage extends BasePage {
    constructor() {

        super();

        const token = window.appData?.token;
        const locale = window.appData?.locale;
        const auctionId = window.appData?.auctionId;
        const sectionId = window.appData?.sectionId;
        const authorId = window.appData?.authorId;
        const viewerId = window.appData?.viewerId;
        const currencyId = window.appData?.currencyId;
        const cp = window.appData?.cp;

        this.initResource({
            controller: new AuthorThemedLotsController(),
            event: 'forum.authorThemedLots',
            cacheKey: `forum.authorThemedLots.${cp}`,
            payload: { token, locale, auctionId, sectionId, authorId, viewerId, currencyId }
        });

        this.initResource({
            controller: new ThemedLotsController(),
            event: 'forum.themedLots',
            cacheKey: `forum.themedLots.${cp}`,
            payload: { token, locale, auctionId, sectionId, authorId, viewerId, currencyId }
        });
    }
}